// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"cf4d69b5","112":"d67b3a0b","233":"6e5f202f","412":"ec831138","547":"4ed5fb9e","660":"afdae897","774":"5dab9fdb","842":"622ac6b4"}[chunkId] + ".chunk.js";
};